import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=0396a9d9&scoped=true&"
import script from "./dropdown.vue?vue&type=script&setup=true&lang=ts&"
export * from "./dropdown.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=0396a9d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396a9d9",
  null
  
)

export default component.exports